export default "__VITE_ASSET__Ciwu6ImS__"